import React, { useState } from 'react';

const MovieContext = React.createContext({
    mood:"",
    genre:"",
    actor:"",
    language:"",
    showtime:"",
    handleMood: (mood) => {},
    handleGenre: (genre) => {},
    handleActor: (actor) => {},
    handleLanguage: (language) => {},
    handleShowtime: (showtime) => {}
})

export const MovieContextProvider = ({children}) => {
    const [mood,setMood] = useState('');
    const [genre,setGenre] = useState('');
    const [actor,setActor] = useState('');
    const [language,setLanguage] = useState('');
    const [showtime,setShowtime] = useState('');

    const handleMood = (mood) => {
        setMood(mood);
    }

    const handleGenre = (genre) => {
        setGenre(genre)
    }

    const handleActor = (actor) => {
        setActor(actor);
    }

    const handleLanguage = (language) => {
        setLanguage(language);
    }

    const handleShowtime = (showtime) => {
        setShowtime(showtime);
    }

    return <MovieContext.Provider value={{mood,genre,actor,language,showtime,handleMood,handleGenre,handleActor,handleLanguage,handleShowtime}}>
        {children}
    </MovieContext.Provider>
}


export default MovieContext;